import styled from 'styled-components';
import { media } from '@bitcoin-portal/bitcoincom-pkg-theme';
import ContentBlock from '@bitcoin-portal/bitcoincom-pkg-components/dist/ContentBlock';
import Image from '@bitcoin-portal/bitcoincom-pkg-components/dist/Image';

export const StyledContentBlock = styled(ContentBlock)`
  ${media.md`
    margin-bottom: 100px;
  `}
`;

export const HeaderBlock = styled(ContentBlock)`
  padding-top: 40px;
  padding-bottom: 70px;
  margin: 0 auto;

  ${media.md`
    max-width: 650px;
  `}

  ${media.lg`
    max-width: 750px;

    & > h4 {
      padding-bottom: 88px;
    }
  `}

  ${media.xl`
    max-width: 950px;
  `}
`;

export const ImageWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: flex-end;
  overflow: visible;
  width: 100%;

  & > span {
    display: inline-flex !important;
    justify-content: center;
  }

  ${media.md`
    justify-content: flex-start;
    max-height: 250px;
  `}

  ${media.xl`
    max-height: 490px;
  `}
`;

export const StyledImage = styled(Image)`
  filter: drop-shadow(0px 20px 51px rgba(39, 147, 255, 0.6));
  margin-bottom: 40px;
  width: 231px;
  height: 199px;

  ${media.md`
    filter: drop-shadow(0px 28px 71px rgba(39, 147, 255, 0.6));
    margin-bottom: 0;
    width: 323px;
    height: 279px;
  `}

  ${media.xl`
    filter: drop-shadow(0px 44px 110px rgba(39, 147, 255, 0.6));
    width: 635px;
    height: 548px;
  `}
`;
